// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__22EwR","containerItemsCenter":"Skeleton_containerItemsCenter__3jbFu"};